<template>
    <div class="relative flex-1 min-h-screen">
        <div class="decoration" :class="{'decoration--question': !authVisible}">
            <div class="decoration__inner max-w-7xl w-full h-full mx-auto">
                <PointsCircle class="points-circle" />
                <div class="blue-circle" />
            </div>
        </div>
        <Header :question-mode="!authVisible">THE TRICK TEST</Header>
        <Intro v-if="authVisible" @submit="performAuth"/>
        <Quiz v-else-if="questions.length" :questions="questions" :user="user" :type="type"/>
    </div>
    <Footer />
</template>

<script>
import Quiz from "../../Components/Quiz";
import User from "../../Modules/User";
import Intro from "../../Components/Intro";
import Header from "../../Common/Header.vue";
import Footer from "../../Common/Footer.vue";
import PointsCircle from "../../Components/Vector/PointsCircle.vue";

export default {
	name: "IndexComponent",
	components: {
		PointsCircle,
		Header,
		Footer,
		Intro,
		Quiz
	},
	props: {
		hash: String,
		slug: String
	},
	data: () => ({
		type: "kids",
		questions: [],
		responses: [],
		authVisible: false,
		exitVisible: false,
		user: new User,
	}),
	methods: {
		loadQuestions() {
			if (this.user.hasQuestions) {
				return this.user.questions;
			}
			return window.axios.get(`/api/questions/${this.type}`)
				.then(({data}) => data.data)
				.then(data => {
					this.user.questions = data;
					return data;
				});

		},
		orderQuestions(questions) {
			const findQuestion = questions => {
				for(const index in questions) {
					const question = questions[index];
					if (question.slug === this.slug || question.hash === this.hash) {
						return {index, question};
					}
				}
				return null;
			};
			if (!this.hash && !this.slug) {
				return questions;
			}

			const {index, question} = findQuestion(questions);
			questions[index] = questions[0];
			questions[0] = question;
			return questions;
		},
		loadData() {
			if (this.user.hasQuestions) {
				this.questions = this.user.questions;
				return;
			}

			this.isLoading = true;
			window.axios.get(`/api/questions/${this.type}`)
				.then(({data}) => data.data)
				.then(data => {
					this.user.questions = data;
					this.questions = this.orderQuestions(data);
					this.isLoading = false;
				});
		},
		loadUser() {
			this.user = User.load(this.type);
			if (this.user.isEmpty) {
				this.showAuth();
			}
		},
		showAuth() {
			this.authVisible = true;
		},
		hideAuth() {
			this.authVisible = false;
		},
		performAuth(data) {
			this.user = new User({...data, questions: this.questions});
			this.user.save(this.type);
			this.hideAuth();
			this.scrollToTop();
		},
		scrollToTop() {
			setTimeout(() => {document.body.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});}, 100);
		},
		scrollToImage() {
			setTimeout(() => {document.querySelector(".question-image").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});}, 100);
		},
		reset() {
			this.user.reset(this.type);
			this.scrollToTop();
			this.showAuth();
			this.loadData();
		},
		resetFull() {
			this.user.reset(this.type, true);
			this.scrollToTop();
			this.showAuth();
			this.loadData();
		},
		markAdvanced(position) {
			this.user.setPosition(this.type, position);
			this.user.setQuestions(this.type, this.questions);
			this.scrollToImage();
		},
		markAnswer(question, answer) {
			this.addToResponses(answer);
			this.user.addAnswer(this.type, answer);
			this.user.setQuestions(this.type, this.questions);
			window.axios.post(`/api/questions/${question.id}/responses`, {
				"user_id": this.user.id,
				"answers": [answer.id]
			});
		},
		addToResponses(answer) {
			for (let response of this.responses) {
				if (response.answer_id === answer.id &&
                    response.question_id === answer.question_id) {
					response.count += 1;
					return;
				}
			}
			this.responses.push({
				"answer_id": answer.id,
				"question_id": parseInt(answer.question_id),
				"count": 1
			});
		},

		addEmitterEvents() {
			window.emitter.on("markAnswer", this.markAnswer);
			window.emitter.on("markAdvanced", this.markAdvanced);
			window.emitter.on("reset", this.reset);
			window.emitter.on("forceReset", this.resetFull);
		},
		stay() {
			this.exitVisible = false;
		}
	},
	created() {
		this.loadUser();
		this.loadData();
		this.addEmitterEvents();
	},
};
</script>

<style lang="scss">

#app {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100%;

    .content {
        max-width: 100%;
        padding: 0 15px;
        &.content--full-mobile {
            padding: 0;
        }
    }

    @media (min-width: 1024px) {
        .content {
            max-width: 870px;
            width: 100%;
            margin-right: auto;
            margin-left: auto;
            padding: 0;
        }
    }

    .decoration {
        position: absolute;
        width: 100vw;
        height: 100%;
        bottom: 0;
        left: 0;

        overflow: hidden;

        .decoration__inner {
            position: absolute;
            left: 50%;
            width: 100%;
            transform: translateX(-50%);


            .points-circle {
                display: none;
            }

            .blue-circle {
                position: absolute;
                bottom: -70vh;
                width: 150vh;
                height: 150vh;
                border-radius: 50%;
                background: var(--light-blue);
                right: 50%;
                transform: translateX(40%);
                transition: all .4s cubic-bezier(.47,1.64,.41,.8);
            }

        }
        &.decoration--question {
            .blue-circle {
                bottom: -55%;
                height: 100%;
                transform: translateX(50%);
            }
        }
    }

    @media (min-width: 1024px) {
        .decoration {
            .decoration__inner {
                .blue-circle {
                    bottom: -60vw;
                    left: -30%;
                    width: 110vw;
                    height: 110vw;
                    transition: all .4s cubic-bezier(.47,1.64,.41,.8);
                }

                .points-circle {
                    display: block;
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    z-index: 2;
                    transition: transform .4s cubic-bezier(.47,1.64,.41,.8);
                }
            }
            &.decoration--question {
                .points-circle {
                    transform: translateX(-400%);
                }
                .blue-circle {
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
    }

}
</style>
